import { createContext, useContext, type ReactNode } from 'react';

const DetailViewContext = createContext(false);

export function DetailViewProvider({ children }: { children: ReactNode }) {
    return <DetailViewContext.Provider value={true}>{children}</DetailViewContext.Provider>;
}

/** True when rendered inside a detail drawer/panel (enables copy actions on refs). */
export function useIsDetailView(): boolean {
    return useContext(DetailViewContext);
}
